<img
  [src]="logoUrl"
  [alt]="organizationName"
  (error)="onLogoError($event)"
  class="partner-logo"
/>
